<template>
  <div class="dashboard" v-if="progress">
    <b-loading is-full-page :active.sync="loading">
      <svg
        xmlns:svg="http://www.w3.org/2000/svg"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        version="1.0"
        width="128px"
        height="128px"
        viewBox="0 0 128 128"
        xml:space="preserve"
      >
        <g>
          <path
            d="M88.63 14.92c5.97.1 5.57.83 5.55.8-7.6 5.3-20.67 1.82-20.7 2.3 0 .08-.8 1.7-4.27 2.3a25.78 25.78 0 0 1-3.2.4l-1.4.06q-.3 0-.6.02t-.5 0a18.9 18.9 0 0 1-2.3-.06c3.2-.64 4.6-2.96 4.4-3.05-8.3.1-13.6-2-20.4-1.3-5.8.7-8.9 7-11.8 10.2l-1-16.6c2.1 2 9.1 2.3 12.8 1.6C48.8 10.8 62 5 68.5 5.4c.85-.06-3.6-4.6-3.55-4.5 8-.07 10.4 4.35 10.47 4.36a38.56 38.56 0 0 1 14.1 5.1c1.84 1.1 3.4 2.1 4.4 2.85l1.2.9.3.3.05.1c-4.67-.5-7.03.4-6.83.4zm-18.2 4.58c2.1-.76 1.9-2.02 1.9-2a3.2 3.2 0 0 1-2 1.7 23.66 23.66 0 0 1-3.63 1.05 16.07 16.07 0 0 0 3.74-.75zm-3.98.1a11.63 11.63 0 0 0 2.7-.53c1.53-.55 1.37-1.46 1.37-1.45a2.32 2.32 0 0 1-1.44 1.23 17.12 17.12 0 0 1-2.63.76zm6.3-15.8c-1.47-1.67-5.9-2.16-5.88-2.15a16.36 16.36 0 0 1 4.4 1.6 9.18 9.18 0 0 1 2.56 2.13s.08-.23-1.1-1.57zm2.28 8.66c0 4.58 2.57 5.05 2.55 5.03a6.6 6.6 0 0 1-1.9-5.1 8.37 8.37 0 0 1 2.65-5.3 6.24 6.24 0 0 0-3.3 5.3zm9.76-3.32A2.87 2.87 0 1 0 87.6 12a2.87 2.87 0 0 0-2.87-2.86zm-1.1 3.47a1.8 1.8 0 0 0 1.5 1.8 2.42 2.42 0 1 1 2-2.4v.1a1.8 1.8 0 0 0-3.5.5zm-13-9.1a7.08 7.08 0 0 0-3.1-1 5.72 5.72 0 0 1 2.8 1.3 8.3 8.3 0 0 1 1.8 1.8 5.95 5.95 0 0 0-1.7-2.1zm-32.4 14c-2 1.1-3.5 5.2-3.5 5.2a16.36 16.36 0 0 1 2.6-3.8 9.18 9.18 0 0 1 2.6-2s-.2-.1-1.8.7zm-.5-1.3c-1.9.6-3.9 3.9-3.9 3.9a14.22 14.22 0 0 1 2.8-2.9 7.98 7.98 0 0 1 2.6-1.2s-.2-.2-1.6.3zm-1.5-1.6a3.8 3.8 0 0 0-2.4 2.1 7.2 7.2 0 0 1 2.5-1.7 7.1 7.1 0 0 1 3-.3 4.7 4.7 0 0 0-3.1 0zm-1-1.1a3.6 3.6 0 0 1-2.1-1.3 6.64 6.64 0 0 0 2.3 1 15.1 15.1 0 0 0 3.1.3 9.96 9.96 0 0 1-3.3.1zm58.3 96.2c-3.1 5.1-3.5 4.4-3.5 4.4-.8-9.2 8.7-18.8 8.3-19.1-.1 0-1.1-1.5.1-4.8a25.8 25.8 0 0 1 1.3-3l.6-1.2.3-.5.23-.5a18.96 18.96 0 0 1 1.2-1.9c-1.07 3.1.26 5.5.44 5.3 4.1-7.3 8.5-10.8 11.3-17 2.3-5.4-1.6-11.3-2.9-15.3l14.8 7.5c-2.76.8-6.5 6.7-7.8 10.3-1.15 3.64-2.68 18-6.27 23.4-.4.77 5.8-.83 5.66-.82-3.9 7-8.9 6.86-9 6.9a38.56 38.56 0 0 1-11.5 9.7c-1.8 1.06-3.5 1.86-4.7 2.4l-1.3.6-.4.1c-.03 0-.06 0-.1.03 2.8-3.8 3.2-6.3 3.1-6.1zm5.1-18c-.4 2.2.8 2.7.8 2.7a3.2 3.2 0 0 1-.5-2.6 23.62 23.62 0 0 1 .9-3.6 16.06 16.06 0 0 0-1.2 3.6zm1.9-3.5a11.6 11.6 0 0 0-.9 2.6c-.3 1.6.6 1.9.6 1.9a2.33 2.33 0 0 1-.4-1.8 17.04 17.04 0 0 1 .6-2.7zm10.5 13.4c2.2-.4 4.8-4 4.8-4a16.36 16.36 0 0 1-3.6 3 9.16 9.16 0 0 1-3.2 1.2s.2.2 1.9-.1zm-8.7-2.3c-3.9-2.3-5.6-.3-5.6-.3a6.6 6.6 0 0 1 5.3.9 8.37 8.37 0 0 1 3.2 5 6.24 6.24 0 0 0-2.98-5.5zm-2 10.1a2.87 2.87 0 1 0-3.9 1.1 2.87 2.87 0 0 0 3.9-1zm-2.4-2.6a1.8 1.8 0 0 0-2.3.5 2.45 2.45 0 0 1 .2-.4 2.42 2.42 0 1 1 .9 3.3 1.8 1.8 0 0 0 1.3-3.3zm14.4-6.6a7.08 7.08 0 0 0 2.4-2.1 5.72 5.72 0 0 1-2.5 1.8 8.27 8.27 0 0 1-2.5.7 5.94 5.94 0 0 0 2.6-.33zm4-35.02c.1-2.22-2.7-5.62-2.7-5.6a16.37 16.37 0 0 1 2.04 4.2 9.16 9.16 0 0 1 .37 3.3s.2-.1.3-1.9zm1.4.27c.5-1.9-1.4-5.3-1.4-5.3a14.2 14.2 0 0 1 1.1 3.9 7.97 7.97 0 0 1-.2 2.9s.2-.1.54-1.6zm2.1-.5a3.78 3.78 0 0 0-.53-3.17 7.2 7.2 0 0 1 .2 3 7.1 7.1 0 0 1-1.2 2.76 4.7 4.7 0 0 0 1.5-2.6zm1.46-.37a3.6 3.6 0 0 1 2.2-1.16 6.63 6.63 0 0 0-2.04 1.5 15.14 15.14 0 0 0-1.76 2.6 9.98 9.98 0 0 1 1.6-2.9zM9.12 66.8c-2.9-5.24-2.04-5.25-2.1-5.22 8.4 3.93 11.9 17 12.3 16.78.1-.03 1.9-.15 4.18 2.54a25.78 25.78 0 0 1 2 2.65c.3.4.6.8.8 1.18q.2.27.3.53t.3.5a18.9 18.9 0 0 1 1.1 2c-2.12-2.46-4.8-2.48-4.8-2.26 4.34 7.2 5.1 12.78 9.1 18.3 3.6 4.68 10.6 4.24 14.8 5.14.1-.05-13.92 9.1-13.9 9.08.68-2.8-2.54-9-5-11.9-2.6-2.8-14.26-11.3-17.12-17.12-.47-.72-2.2 5.44-2.12 5.32-4.1-6.92-1.47-11.2-1.5-11.24a38.56 38.56 0 0 1-2.56-14.8c0-2.15.12-3.98.25-5.26l.12-1.48.06-.38.03-.1h.02c1.87 4.32 3.86 5.9 3.74 5.74zM22.2 80.25c-1.7-1.43-2.7-.62-2.68-.62a3.2 3.2 0 0 1 2.47.87 23.66 23.66 0 0 1 2.7 2.62 16.08 16.08 0 0 0-2.5-2.87zm2.1 3.4a11.62 11.62 0 0 0-1.84-2.07c-1.3-1.04-2-.45-2-.45a2.32 2.32 0 0 1 1.8.63 17.1 17.1 0 0 1 2 1.9zM7.48 86.13c-.74 2.1 1.05 6.18 1.05 6.17a16.36 16.36 0 0 1-.82-4.6 9.18 9.18 0 0 1 .6-3.3s-.2.05-.8 1.73zm6.33-6.3c4-2.3 3.1-4.76 3.1-4.74a6.6 6.6 0 0 1-3.4 4.1 8.37 8.37 0 0 1-5.9.3 6.24 6.24 0 0 0 6.3.2zm-7.7-6.8a2.87 2.87 0 1 0 1-3.93 2.87 2.87 0 0 0-1 3.93zm3.6-.8a1.8 1.8 0 0 0 .7-2.23 2.42 2.42 0 1 1-3-.5l.1-.08a1.8 1.8 0 0 0 2.2 2.8zm-1.5 15.8a7.08 7.08 0 0 0 .7 3.13 5.72 5.72 0 0 1-.3-3.07 8.3 8.3 0 0 1 .7-2.6 5.95 5.95 0 0 0-1 2.4zm28.4 21c1.9 1.22 6.3.44 6.3.45a16.4 16.4 0 0 1-4.6-.3 9.2 9.2 0 0 1-3-1.33s0 .24 1.5 1.2zm-.9 1.08c1.4 1.4 5.3 1.4 5.3 1.4a14.2 14.2 0 0 1-3.9-1 7.97 7.97 0 0 1-2.4-1.6s0 .2 1.1 1.3zm-.6 2.1a3.8 3.8 0 0 0 3 1.1 7.2 7.2 0 0 1-2.7-1.3 7.1 7.1 0 0 1-1.8-2.4 4.7 4.7 0 0 0 1.6 2.7zm-.4 1.5a3.6 3.6 0 0 1-.1 2.5 6.63 6.63 0 0 0-.3-2.5 15.1 15.1 0 0 0-1.3-2.8 9.97 9.97 0 0 1 1.7 2.9z"
            fill="#000000"
            fill-opacity="1"
          />
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 64 64"
            to="120 64 64"
            dur="1680ms"
            repeatCount="indefinite"
          />
        </g>
      </svg>
    </b-loading>
    <span v-if="!loading">
      <div class="columns">
        <div class="column is-three-quarters">
          <h1 class="title is-3">Scale Academy</h1>
          <p>{{ courseData.desc }}</p>
          <h1 class="title is-4">Course Progress</h1>
          <h3 class="subtitle is-5">{{ Math.floor(percentComplete) }}% complete</h3>
          <router-link
            v-if="currentModule === 1 && currentStep === 1"
            :to="'/course/' + currentModule + '/' + currentStep"
          >
            <b-button type="is-primary" rounded>Start</b-button>
          </router-link>

          <router-link
            v-else-if="!courseComplete"
            :to="'/course/' + currentModule + '/' + currentStep"
          >
            <b-button type="is-primary" rounded>Continue</b-button>
          </router-link>

          <div v-else>
            <h3 class="subtitle is-4">Course complete</h3>
          </div>
          <br />
          <br />
          <div v-for="m in courseData.modules" :key="m.id">
            <router-link
              v-if="progress.progress.modules[m.number - 1].complete"
              tag="div"
              :class="[{'complete':progress.progress.modules[m.number - 1].complete},'course_module']"
              :to="'/course/' + m.number + '/1'"
            >
              <p>{{ m.title }}</p>
            </router-link>
            <div v-else class="course_module">
              <p>{{ m.title }}</p>
            </div>
          </div>
        </div>
        <div class="column">
          <h1 class="title is-4">Course Tools</h1>
          <ul>
            <li><router-link to="/glossary">Glossary</router-link></li>
            <li>
              <a
                href="https://hamachan.shinyapps.io/AgingError/"
                target="_blank"
                >Aging Errors</a
              >
            </li>
            <router-link tag="li"
              class="course-tool-link"
              to="/tool/scaleanatmony"
            >
              Scale Anatomy
            </router-link>
            <li
              class="course-tool-link"
              @click="OpenCourseTool('FishAnimation')"
            >
              Fish Scale Animation
            </li>
            <li class="course-tool-link" @click="OpenCourseTool('ScaleDemo')">
              Scale Retrieval Demo
            </li>
          </ul>
          <h1 class="title is-4">Literature</h1>
          <ul class="literature">
            <li>
              <a
                href="https://scaleapi.designori.net/uploads/Koo_1962_bc06a3761f.pdf"
                target="_blank"
                >Age Designation In Salmon</a
              >
            </li>
            <li>
              <a
                href="https://scaleapi.designori.net/uploads/Mosher_1963_819d08eba4.pdf"
                target="_blank"
                >Racial Analysis Of Red Salmon By Means Of Scales</a
              >
            </li>
            <li>
              <a
                href="https://scaleapi.designori.net/uploads/Bigler_1989_4d4797be1e.pdf"
                target="_blank"
                >Mechanism and Occurrence of Focal Scale Resorption (Chum Salmon)</a
              >
            </li>
            <li>
              <a
                href="https://scaleapi.designori.net/uploads/Clutter_and_Whitsel_1956_75a86daf20.pdf"
                target="_blank"
                >Collection And Interpretation Of Sockeye Salmon Scales</a
              >
            </li>
          </ul>
        </div>
      </div>
      <b-modal
        :active.sync="CourseToolsOpen"
        has-modal-card
        trap-focus
        :destroy-on-hide="false"
        aria-role="dialog"
        aria-modal
      >
        <div class="modal-card" style="width: auto">
          <scale-anatomy v-if="WhichCourseTool == 'ScaleAnatmony'" small />
          <video-player
            v-if="WhichCourseTool == 'FishAnimation'"
            src="https://player.vimeo.com/video/442819907"
            width="640"
            height="360"
          ></video-player>
          <video-player
            v-if="WhichCourseTool == 'ScaleDemo'"
            src="https://player.vimeo.com/video/440440681"
            width="640"
            height="360"
          ></video-player>
        </div>
      </b-modal>
    </span>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";

// import Scaleaging from "@/interact/Scaleaging.vue";
import ScaleAnatomy from "@/interact/ScaleAnatomy.vue";
import VideoPlayer from "@/interact/VideoPlayer.vue";

export default {
  name: "Dashboard",
  components: {
    ScaleAnatomy,
    VideoPlayer
  },
  data() {
    return {
      courseComplete: false,
      CourseToolsOpen: false,
      WhichCourseTool: "",
      loading: true,
      currentModule: null,
      currentStep: null,
      totalSteps: 0,
      stepsComplete: 0,
      percentComplete: 0,
    };
  },
  async mounted() {
    console.log("Dashboard...");
    await this.setCourseActive(false);
    await this.getCourseAction();
    await this.getProgressAction().then(response => {
      if (typeof response === "undefined") {
        //no progress, create one
        this.createProgressAction();
        this.currentModule = 1;
        this.currentStep = 1;
      } else {
        //find user's progress in course:
        //loop mods
        response.progress.modules.forEach(m => {
          if (m.complete) {
            // module complete add step count to total
            this.totalSteps += m.steps.length;
            this.stepsComplete += m.steps.length;
          } else {
            //mod not complete, set it as the current if it hasn't yet been set
            if (this.currentModule == null) {
              this.currentModule = m.number;
            }
            //loop steps in mod
            m.steps.forEach((step, index) => {
              //add step to total count
              this.totalSteps += 1;
              if (step.complete) {
                this.stepsComplete += 1;
              } else {
                //set step as current if it hasn;t yet been set
                if (this.currentStep == null) {
                  this.currentStep = index + 1;
                }
              }
            });
          }
        });
        //if not module was set, then the course is complete, but set it as the last mod, step 1
        if (this.currentModule == null) {
          this.currentModule = response.progress.modules[response.progress.modules.length - 1].number;
          this.courseComplete = true;
          this.currentStep = 1;
        }
        //set percentage complete
        this.percentComplete = this.stepsComplete / this.totalSteps * 100;
      }
      this.setCurrentStep({
        module: this.currentModule,
        step: this.currentStep
      });
      this.loading = false;
    });
  },
  methods: {
    ...mapActions("course", [
      "getCourseAction",
      "getProgressAction",
      "createProgressAction"
    ]),
    ...mapMutations("course", ["setCurrentStep"]),
    setCourseActive(courseActive) {
      this.$store.commit("setCourseActive", courseActive);
    },
    OpenCourseTool(which) {
      this.WhichCourseTool = which;
      this.CourseToolsOpen = true;
    }
  },
  computed: {
    ...mapGetters("course", {
      courseData: "courseData",
      progress: "progress",
      moduleLength: "moduleLength",
      step: "step",
      module: "module"
    })
  }
};
</script>

<style lang="scss">
@import "../theme.scss";

.dashboard {
  .title {
    margin-top: 50px;
  }

  .course_module {
    background-color: #efefef;
    width: 300px;
    padding: 20px;
    margin: 10px 0px;
    border-radius: 15px;
  }

  .complete {
    background-color: #6eb368;
    cursor: pointer;

    &:hover {
      background-color: $primary;
    }
  } 

  .course-tool-link {
    cursor: pointer;
    color: $primary;

    &:hover {
      color: $secondary;
    }
  }

  ul.literature li {
    padding: 5px 0px;
  }

}
</style>
